import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { Button } from "../components/ui/button";
import { Wine } from "lucide-react";
import FavoriteButton from "./FavoriteButton";
import ProductZoom from "./ProductZoom";
import { useLang } from "../contexts/LangContext";

export default function WineCardB2C({ wine }) {
  const { add } = useCart();
  const { t, formatPrice } = useLang();
  return (
    <div data-testid={`wine-b2c-card-${wine.id}`} className="group bg-card border border-border rounded-sm overflow-hidden hover-lift h-full flex flex-col relative">
      <div className="absolute top-3 right-3 z-20">
        <FavoriteButton productType="wine" productId={wine.id} meta={{ name: wine.name, image: wine.image, price: wine.price_per_bottle }} />
      </div>
      <div className="relative aspect-[4/5] bg-white">
        <ProductZoom src={wine.image} alt={`${wine.name} ${wine.vintage}`} imgClassName="scale-[1.05]" />
        <div className="absolute top-3 left-3 chip bg-white/95 text-[hsl(var(--primary))] pointer-events-none">
          {wine.denomination}
        </div>
        <div className="absolute bottom-2 left-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-[hsl(var(--primary))] pointer-events-none">
          {wine.region}
        </div>
      </div>
      <div className="p-4 md:p-5 flex-1 flex flex-col">
        <Link to={`/b2b/wines/${wine.id}`} className="block">
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">{wine.winery} · {wine.vintage}</div>
          <h3 className="editorial-heading text-xl leading-tight mt-1">{wine.name}</h3>
          <div className="text-xs text-muted-foreground mt-1">{wine.grape} · {wine.alcohol}% vol</div>
          <div className="text-[10px] text-muted-foreground mt-0.5">{wine.region} · {wine.country || "Italia"}</div>
        </Link>
        <div className="mt-auto pt-4 flex items-center justify-between">
          <div className="text-lg font-bold text-[hsl(var(--primary))]">{formatPrice(wine.price_per_bottle)}<span className="text-xs font-normal text-muted-foreground"> /btl</span></div>
          <Button
            data-testid={`wine-add-${wine.id}`}
            size="sm"
            onClick={() => add({ product_id: wine.id, product_type: "wine", name: `${wine.name} ${wine.vintage}`, image: wine.image, unit_price: wine.price_per_bottle, quantity: 1, unit: "bottle" })}
            className="bg-[hsl(var(--secondary))] text-white hover:bg-[hsl(var(--secondary))]/90 rounded-sm text-xs gap-1"
          >
            <Wine className="h-3 w-3" />{t("ui.add_to_cart", "Aggiungi")}
          </Button>
        </div>
      </div>
    </div>
  );
}
